var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7145 26.3483C27.0464 26.8494 26.75 27.4461 26.75 28C26.75 28.5539 27.0464 29.1506 27.7145 29.6516C28.3829 30.153 29.3636 30.5 30.5 30.5C31.6364 30.5 32.6171 30.153 33.2855 29.6516C33.9536 29.1506 34.25 28.5539 34.25 28C34.25 27.4461 33.9536 26.8494 33.2855 26.3483C32.6171 25.847 31.6364 25.5 30.5 25.5C29.3636 25.5 28.3829 25.847 27.7145 26.3483ZM26.2145 24.3483C27.3557 23.4924 28.875 23 30.5 23C32.125 23 33.6443 23.4924 34.7855 24.3483C35.9271 25.2046 36.75 26.4828 36.75 28C36.75 29.5172 35.9271 30.7954 34.7855 31.6517C33.6443 32.5076 32.125 33 30.5 33C28.875 33 27.3557 32.5076 26.2145 31.6517C25.0729 30.7954 24.25 29.5172 24.25 28C24.25 26.4828 25.0729 25.2046 26.2145 24.3483Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71447 30.0983C7.04643 30.5994 6.75 31.1961 6.75 31.75C6.75 32.3039 7.04643 32.9006 7.71447 33.4016C8.38289 33.903 9.3636 34.25 10.5 34.25C11.6364 34.25 12.6171 33.903 13.2855 33.4016C13.9536 32.9006 14.25 32.3039 14.25 31.75C14.25 31.1961 13.9536 30.5994 13.2855 30.0983C12.6171 29.597 11.6364 29.25 10.5 29.25C9.3636 29.25 8.38289 29.597 7.71447 30.0983ZM6.21447 28.0983C7.35569 27.2424 8.87498 26.75 10.5 26.75C12.125 26.75 13.6443 27.2424 14.7855 28.0983C15.9271 28.9546 16.75 30.2328 16.75 31.75C16.75 33.2672 15.9271 34.5454 14.7855 35.4017C13.6443 36.2576 12.125 36.75 10.5 36.75C8.87498 36.75 7.35569 36.2576 6.21447 35.4017C5.07286 34.5454 4.25 33.2672 4.25 31.75C4.25 30.2328 5.07286 28.9546 6.21447 28.0983Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2983 4.53812C36.5844 4.7756 36.75 5.12815 36.75 5.50001V28H34.25V7.00617L16.75 10.2874V31.75H14.25V9.25001C14.25 8.64849 14.6784 8.13227 15.2696 8.02142L35.2696 4.27142C35.6351 4.20289 36.0121 4.30064 36.2983 4.53812Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.b05930c08e445ebe823281b64d370d60.svg";
export { ForwardRef as ReactComponent };